import WAValidator from 'multicoin-address-validator';

export const validateAddress = (address: string, chain: string): boolean => {
  const symbol = chain.toUpperCase(); // "ETH" or "TRX"
  return WAValidator.validate(address, symbol);
};
